<template>
  <div id="dashboard-layout">
    <b-alert
      :show="getAlert.show"
      dismissible
      :variant="getAlert.variant"
      @dismissed="dismissAlert(0)"
      @dismiss-count-down="countDownChanged"
    >
      <div class="container">
        <b-icon
          font-scale="1"
          v-if="getAlert.variant != 'success'"
          icon="exclamation-circle"
        ></b-icon>
        <b-icon font-scale="1" v-else icon="check-circle"></b-icon>
        {{ getAlert.message }} {{ getAlert.show }}
        <div class="pull-right">
          <b-icon
            @click="dismissAlert()"
            font-scale="1.5"
            icon="x-circle"
            class=""
          ></b-icon>
        </div>
      </div>
      <b-progress
        variant="warning"
        :max="100"
        :value="getAlert.show"
        height="5px"
      ></b-progress>
    </b-alert>

    <header id="header">
      <div class="container">
        <b-navbar toggleable="sm" class="justify-content-between">
          <div class="d-flex align-items-center">
            <b-navbar-brand :to="{ name: 'dashboard-home' }">
              <img
                alt="Regenesis Logo"
                class="d-none d-md-block"
                src="@/assets/logo.png"
              />
              <img
                alt="Regenesis Logo"
                class="d-sm-block d-md-none"
                src="@/assets/logo.png"
              />
            </b-navbar-brand>

            <b-navbar-nav class="menu-nav-itens">
              <b-nav-item :to="{ name: 'dashboard-home' }"
                >Espaço Regenesis</b-nav-item
              >
              <b-nav-item :to="{ name: 'pregnancy-data' }"
                >Dados da Gestação</b-nav-item
              >
              <b-nav-item :to="{ name: 'healthy-habits-home' }"
                >Hábitos Saudáveis</b-nav-item
              >
              <b-nav-item :to="{ name: 'antenatal' }">Pré-Natal</b-nav-item>
            </b-navbar-nav>
          </div>

          <div>
            <b-navbar-toggle
              ref="navCollapsButton"
              target="nav-notification"
              style="border: none !important"
            >
              <b-icon icon="bell" class="mr-2"></b-icon>
            </b-navbar-toggle>
            <b-navbar-toggle
              ref="navCollapsButton"
              target="nav-collapse"
              style="border: none !important"
            >
              <img src="@/assets/images/hamburger.svg" alt="menu" />
            </b-navbar-toggle>
          </div>

          <b-collapse
            id="nav-notification"
            is-nav
            @show="showMenu"
            @hide="hideMenu"
          >
            <b-navbar-nav class="ml-auto">
              <b-nav-item-dropdown icon="bell" class="not-filled user-menu">
                <template #button-content>
                  <b-icon icon="bell" class="mr-2"></b-icon>
                </template>
                <div class="inside-menu notifications">
                  <div class="header border-bottom">
                    <div class="d-flex align-items-center">
                      <div class="">
                        <h5>Notificações</h5>
                      </div>
                    </div>
                  </div>
                  <div
                    class="p-4 border-bottom"
                    v-for="(item, index) in notifications.items"
                    :key="index"
                  >
                    <p>{{ notificationTip(item.type) }}</p>

                    <p class="text-muted small">
                      {{ notificationTipMini(item.type) }}
                    </p>

                    <p class="text-muted small">
                      {{ item.createdAt | moment("DD/MM/YYYY") }}
                    </p>
                  </div>

                  <div
                    class="p-4 border-bottom"
                    v-if="notifications.total == 0 || notifications.length == 0"
                  >
                    Sem notificações
                  </div>
                  <div
                    class="footer d-flex justify-content-center py-3"
                    v-if="notifications.total > 0"
                  >
                    <b-button
                      variant="outline-primary"
                      class="px-4"
                      @click="cleanNotifications"
                    >
                      Limpar notificações
                    </b-button>
                  </div>
                </div>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
          <b-collapse
            id="nav-collapse"
            is-nav
            @show="showMenu"
            @hide="hideMenu"
          >
            <b-navbar-nav class="ml-auto">
              <!-- <b-nav-item-dropdown text="+ pré-natal" :disabled="getProfile === null && getUserData === null" :class="getProfile === null && getUserData === null ? 'disabled-filled-dropdown' : 'filled-dropdown'" right>
								<b-dropdown-item class="my-1" href="/app/antenatal-consult">Consulta</b-dropdown-item>
								<b-dropdown-item class="my-1" href="/app/antenatal-ultra">Ultrassom</b-dropdown-item>
								<b-dropdown-item class="my-1" href="/app/antenatal-exam">Exame</b-dropdown-item>
								<b-dropdown-item class="my-1" href="/app/antenatal-vaccine">Vacina</b-dropdown-item>
								<b-dropdown-item class="my-1" href="/app/antenatal-medication">Medicamento
								</b-dropdown-item>
							</b-nav-item-dropdown> -->

              <b-nav-item-dropdown
                :text="userInitials"
                class="filled-rounded user-menu"
              >
                <div class="inside-menu menu-all">
                  <div class="header border-bottom">
                    <div class="d-flex align-items-center">
                      <div class="filled-rounded">
                        <div class="nav-link m-0">{{ userInitials }}</div>
                      </div>
                      <div class="ml-3">
                        <h5 v-if="getUser">{{ getUser.name }}</h5>
                        <small v-if="getUser && tratar(getUser.expires_at) > 0" class="text-muted"
                          >{{ tratar(getUser.expires_at) }} dias restantes</small
                        >
                        <small v-else class="text-muted"
                          >Expirado</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="p-4 border-bottom">
                    <b-button
                      :to="{ name: 'new-cupom' }"
                      variant="outline-primary"
                      block
                      >Enviar um novo cupom</b-button
                    >
                  </div>
                  <div class="border-bottom py-4 nav-wrapper">
                    <ul class="menu">
                      <b-dropdown-item href="/app/dashboard">
                        Espaço Regenesis</b-dropdown-item
                      >
                      <b-dropdown-item href="/app/pregnancy-data"
                        >Dados da Gestação</b-dropdown-item
                      >
                      <b-dropdown-item href="/app/healthy-habits"
                        >Hábitos Saudáveis</b-dropdown-item
                      >
                      <b-dropdown-item href="/app/antenatal"
                        >Pré-Natal</b-dropdown-item
                      >
                    </ul>
                  </div>

                  <div class="py-4">
                    <ul>
                      <b-dropdown-item href="/app/my-data"
                        >Meus dados</b-dropdown-item
                      >
                      <b-dropdown-item href="/app/change-password"
                        >Trocar senha</b-dropdown-item
                      >
                      <b-dropdown-item href="/app/terms-and-privacy"
                        >Política de privacidade e de Dados</b-dropdown-item
                      >
                      <b-dropdown-item href="/app/terms"
                        >Regulamento da plataforma</b-dropdown-item
                      >
                      <b-dropdown-item @click.prevent="logout()" href="#"
                        >Sair</b-dropdown-item
                      >
                    </ul>
                    <!-- <ul>
											<li></li>
											<li><a href="#" @click.prevent="changeRoute('my-data')">Meus dados</a></li>
											<li><a href="#" @click.prevent="changeRoute('change-password')">Trocar senha</a></li>
											<li><a href="#" @click.prevent="changeRoute('terms-and-privacy')">Política de privacidade e de Dados</a></li>
											<li><a href="#" @click.prevent="changeRoute('terms')">Regulamento da plataforma</a></li>
											<li><a href="#" @click.prevent="logout()">Sair</a></li>
										</ul> -->
                  </div>
                </div>
                <!-- <b-dropdown-item @click="logout()">SAIR</b-dropdown-item> -->
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>
    <div class="mb-5">
      <transition name="fade" mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>
    <footer>
      <div class="container">
        <div class="row mb-5">
          <div class="col-md-3">
            <p class="mb-4">
              <img src="@/assets/logo_rede_regenesis_branco.png" />
            </p>
            <a
              href="https://www.youtube.com/channel/UCIqmGUeQa39jrAdd_5uW-Kw"
              target="_blank"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.54 6.42C22.4212 5.94541 22.1793 5.51057 21.8387 5.15941C21.498 4.80824 21.0708 4.55318 20.6 4.42C18.88 4 12 4 12 4C12 4 5.12001 4 3.40001 4.46C2.92925 4.59318 2.50198 4.84824 2.16135 5.19941C1.82072 5.55057 1.5788 5.98541 1.46001 6.46C1.14522 8.20556 0.991243 9.97631 1.00001 11.75C0.988786 13.537 1.14277 15.3213 1.46001 17.08C1.59097 17.5398 1.83831 17.9581 2.17815 18.2945C2.51799 18.6308 2.93883 18.8738 3.40001 19C5.12001 19.46 12 19.46 12 19.46C12 19.46 18.88 19.46 20.6 19C21.0708 18.8668 21.498 18.6118 21.8387 18.2606C22.1793 17.9094 22.4212 17.4746 22.54 17C22.8524 15.2676 23.0063 13.5103 23 11.75C23.0112 9.96295 22.8572 8.1787 22.54 6.42V6.42Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.75 15.02L15.5 11.75L9.75 8.48V15.02Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/regenesisbrasil/"
              target="_blank"
              class="mx-4"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 7C9.20435 7 8.44129 7.31607 7.87868 7.87868C7.31607 8.44129 7 9.20435 7 10C7 10.7956 7.31607 11.5587 7.87868 12.1213C8.44129 12.6839 9.20435 13 10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10C13 9.20435 12.6839 8.44129 12.1213 7.87868C11.5587 7.31607 10.7956 7 10 7ZM10 5C11.3261 5 12.5979 5.52678 13.5355 6.46447C14.4732 7.40215 15 8.67392 15 10C15 11.3261 14.4732 12.5979 13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15C8.67392 15 7.40215 14.4732 6.46447 13.5355C5.52678 12.5979 5 11.3261 5 10C5 8.67392 5.52678 7.40215 6.46447 6.46447C7.40215 5.52678 8.67392 5 10 5ZM16.5 4.75C16.5 5.08152 16.3683 5.39946 16.1339 5.63388C15.8995 5.8683 15.5815 6 15.25 6C14.9185 6 14.6005 5.8683 14.3661 5.63388C14.1317 5.39946 14 5.08152 14 4.75C14 4.41848 14.1317 4.10054 14.3661 3.86612C14.6005 3.6317 14.9185 3.5 15.25 3.5C15.5815 3.5 15.8995 3.6317 16.1339 3.86612C16.3683 4.10054 16.5 4.41848 16.5 4.75ZM10 2C7.526 2 7.122 2.007 5.971 2.058C5.187 2.095 4.661 2.2 4.173 2.39C3.739 2.558 3.426 2.759 3.093 3.093C2.78001 3.3954 2.53935 3.76458 2.389 4.173C2.199 4.663 2.094 5.188 2.058 5.971C2.006 7.075 2 7.461 2 10C2 12.474 2.007 12.878 2.058 14.029C2.095 14.812 2.2 15.339 2.389 15.826C2.559 16.261 2.759 16.574 3.091 16.906C3.428 17.242 3.741 17.443 4.171 17.609C4.665 17.8 5.191 17.906 5.971 17.942C7.075 17.994 7.461 18 10 18C12.474 18 12.878 17.993 14.029 17.942C14.811 17.905 15.338 17.8 15.826 17.611C16.259 17.442 16.574 17.241 16.906 16.909C17.243 16.572 17.444 16.259 17.61 15.829C17.8 15.336 17.906 14.809 17.942 14.029C17.994 12.925 18 12.539 18 10C18 7.526 17.993 7.122 17.942 5.971C17.905 5.189 17.8 4.661 17.61 4.173C17.4593 3.765 17.2191 3.39596 16.907 3.093C16.6047 2.77985 16.2355 2.53917 15.827 2.389C15.337 2.199 14.811 2.094 14.029 2.058C12.925 2.006 12.539 2 10 2ZM10 0C12.717 0 13.056 0.00999994 14.122 0.0599999C15.187 0.11 15.912 0.277 16.55 0.525C17.21 0.779 17.766 1.123 18.322 1.678C18.8305 2.1779 19.224 2.78259 19.475 3.45C19.722 4.087 19.89 4.813 19.94 5.878C19.987 6.944 20 7.283 20 10C20 12.717 19.99 13.056 19.94 14.122C19.89 15.187 19.722 15.912 19.475 16.55C19.2247 17.2178 18.8311 17.8226 18.322 18.322C17.822 18.8303 17.2173 19.2238 16.55 19.475C15.913 19.722 15.187 19.89 14.122 19.94C13.056 19.987 12.717 20 10 20C7.283 20 6.944 19.99 5.878 19.94C4.813 19.89 4.088 19.722 3.45 19.475C2.78233 19.2245 2.17753 18.8309 1.678 18.322C1.16941 17.8222 0.775931 17.2175 0.525 16.55C0.277 15.913 0.11 15.187 0.0599999 14.122C0.0129999 13.056 0 12.717 0 10C0 7.283 0.00999994 6.944 0.0599999 5.878C0.11 4.812 0.277 4.088 0.525 3.45C0.775236 2.78218 1.1688 2.17732 1.678 1.678C2.17767 1.16923 2.78243 0.775729 3.45 0.525C4.088 0.277 4.812 0.11 5.878 0.0599999C6.944 0.0129999 7.283 0 10 0Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href="https://www.facebook.com/regenesisbrasil" target="_blank">
              <svg
                width="11"
                height="20"
                viewBox="0 0 11 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 11.5H9.5L10.5 7.5H7V5.5C7 4.47 7 3.5 9 3.5H10.5V0.14C10.174 0.0970001 8.943 0 7.643 0C4.928 0 3 1.657 3 4.7V7.5H0V11.5H3V20H7V11.5Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
          <div class="col-md-3">
            <p class="mb-2"><strong>Contato</strong></p>
            <p class="mb-0">0800 607 5556</p>
            <p class="mb-0">contato@rederegenesis.com.br</p>
          </div>
          <div class="col-md-3">
            <p class="mb-2"><strong>Endereço</strong></p>
            <p class="mb-0">R. Helena, 260 - 4º Andar</p>
            <p class="mb-0">Conjuntos 42 e 44</p>
            <p class="mb-0">Vila Olímpia - São Paulo/SP</p>
            <p class="mb-0">CEP: 04552-050</p>
          </div>
          <div class="col-md-3">
            <p class="mb-2">
              <a href="/app/terms-and-privacy" target="_blank"
                ><strong>Política de privacidade e de Dados</strong></a
              >
            </p>
            <p class="mb-2">
              <a href="/register/terms" target="_blank"
                ><strong>Regulamento da Plataforma</strong></a
              >
            </p>
            <p class="mb-0">@ 2022 Rede Regenesis</p>
            <p class="mb-0">Todos os direitos reservados</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "Login",
    data() {
      return {
        notifications: [],
      };
    },
    computed: {
      ...mapGetters({
        getProfile: "user/getProfile",
        getUserData: "user/getUserData",
        getUser: "user/getUser",
        getAlert: "dashboard/getAlerts",
        getNotifications: "user/getNotifications",
      }),
      userInitials() {
        let item = JSON.parse(localStorage.getItem("user"));
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");
        let initials = [...item.name.matchAll(rgx)] || [];
        initials = (
          (initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
        ).toUpperCase();
        return initials;
      },
      closeMenu() {},
    },
    async created() {
      let data = await this.userNotifications();
      this.notifications = data;
    },
    methods: {
      ...mapActions({
        clearProfile: "user/doLogout",
        userNotifications: "user/userNotifications",
        deleteNotifications: "user/deleteMyNotifications",
      }),
      async cleanNotifications() {
        try {
          let data = await this.deleteNotifications();
          this.$store.commit("dashboard/SET_ALERT", {
            show: 4,
            variant: "success",
            message: "Notificações excluídas com sucesso!",
          });
          setTimeout(() => {
            window.location.reload();
          }, 4000);
        } catch (error) {
          console.log(error);
          this.$store.commit("dashboard/SET_ALERT", {
            show: 5,
            variant: "danger",
            message:
              "Erro ao excluir as notificações, porfavor tente novamente!",
          });
        }
      },
      notificationTip(item) {
        switch (item) {
          case "weight":
            return "Atualização de peso";
          case "recommendation":
            return "Atualização de Recomendações";
          case "reschedule":
            return "Reagendar consulta";
          case "pending_schedule_nutricionista":
            return "Agendamento de consulta";
          case "pending_schedule_psicologo":
            return "Agendamento de consulta";
          case "pending_schedule_personal":
            return "Agendamento de consulta";
          case "prenatal":
            return "Adicione ao pré-natal";
          default:
            break;
        }
      },
      notificationTipMini(item) {
        switch (item) {
          case "weight":
            return "Acompanhar seu peso durante a gestação é muito importante. Atualize rapidamente.";
          case "recommendation":
            return "Verifique nossas recomendações e informe a realização para elaborarmos o seu pré-natal.";
          case "reschedule":
            return "Você perdeu sua consulta. Não deixe de reagendar!";
          case "pending_schedule_nutricionista":
            return "O prazo de agendamento com Nutricionista termina dia . Não deixe de agendar!";
          case "pending_schedule_psicologo":
            return "O prazo de agendamento com Psicólogo termina dia . Não deixe de agendar!";
          case "pending_schedule_personal":
            return "O prazo de agendamento com Personal termina dia . Não deixe de agendar!";
          case "prenatal":
            return "Adicione tudo o que ocorre durante seu pré-natal. Clique em Adicionar ao pré-natal e detalhe suas consultas, ultrassom, medicações etc.";
          default:
            break;
        }
      },
      showMenu() {
        document.body.classList.add("overflow-hidden");
      },
      hideMenu() {
        document.body.classList.remove("overflow-hidden");
      },
      tratar(item) {
        var date1 = new Date();
        var date2 = new Date(item);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if(date1 > date2)
            return -diffDays;
        else
            return diffDays;
      },
      changeRoute(route) {
        this.$refs.navCollapsButton.click();
        this.$router.push({ name: route });
      },
      logout() {
        this.$nextTick(() => {
          this.$refs.navCollapsButton.click();
        });
        this.clearProfile();
        this.$router.push({
          path: "/login",
          replace: true,
        });
      },
      countDownChanged(dismissCountDown) {
        this.$store.commit("dashboard/SET_ALERT", {
          show: dismissCountDown,
          message: this.getAlert.message,
          variant: this.getAlert.variant,
        });
      },
      dismissAlert(value) {
        this.$store.commit("dashboard/SET_ALERT", {
          show: value,
          message: "",
          variant: "",
        });
      },
    },
    beforeRouteLeave: function (to, from, next) {
      document.body.classList.remove("overflow-hidden");
      next();
    },
    mounted() {
      document.body.classList.remove("overflow-hidden");
    },
  };
</script>

<style lang="scss">
  body {
    background: #f3f3f3;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }

  #dashboard-layout {
    display: flex;
    height: 100%;
    flex-direction: column;

    .alert + header#header {
      top: 80px;
    }
  }

  .notifications {
    .dropdown-menu {
      overflow: auto;
      height: 80vh;
    }
  }

  header#header {
    background: #fff;
    border-bottom: 1px solid #e9e9e9;
    position: fixed;
    width: 100%;
    z-index: 10;
    padding: 0;

    // padding: 12px 0px 12px 0px;
    .navbar-nav {
      &.menu-nav-itens {
        .nav-item {
          display: flex;
          align-items: center;
          margin: 0 0rem;
          @media (min-width: 1200px) {
            margin: 0 0.5rem;
          }
          @media (min-width: 1400px) {
            margin: 0 1.5rem;
          }

          .nav-link {
            font-weight: 500;
            font-size: 1rem;
            line-height: 4.2;
            // line-height: 24px;
            //line-height: 4.9rem;
          }
        }
      }
    }

    .navbar {
      padding: 0;

      .b-icon.bi {
        //margin: 0 0.25rem 0 2rem;
        margin: 0 0rem 0 0rem;
        vertical-align: middle;
        font-size: 1.125rem;
        padding: 0 !important;
        align-self: center;
      }

      .nav-link {
        &.router-link-active {
          border-bottom: 1px solid #cc007a;
          color: #cc007a;
        }
      }

      .filled-rounded {
        .nav-link {
          margin-left: 0.55rem;
          height: 40px;
          width: 40px;
          border-radius: 100%;
          background-color: #f5cce4;
          color: #520031;
          font-weight: 400;
          text-align: center;

          &:after {
            display: none;
          }
        }
      }

      .not-filled {
        .nav-link {
          margin-left: 0.55rem;

          &:after {
            display: none;
          }
        }
      }

      .dropdown-menu {
        width: 100%;
      }

      .dropdown-item:hover {
        color: #cc007a;
      }

      .filled-dropdown {
        span {
          color: white;
        }

        .nav-link {
          height: 40px;
          text-align: center;

          &:after {
            display: none;
          }
        }

        align-items: center;
        width: 136px;
        height: 40px;
        background: #cc007a;
        border-radius: 4px;
        color: #ffffff;

        &:after {
          display: none;
        }
      }

      .disabled-filled-dropdown {
        span {
          color: white;
        }

        .nav-link {
          height: 40px;
          text-align: center;

          &:after {
            display: none;
          }
        }

        align-items: center;
        width: 136px;
        height: 40px;
        color: white;
        background: #a5a5a5;
        border-radius: 4px;

        &:after {
          display: none;
        }
      }
    }
  }

  .small {
    font-size: 0.75rem;
  }

  footer {
    background: #000000;
    padding: 3.5rem;
    margin-top: auto;
    color: #fff;
    font-size: 1rem;
    p {
      font-weight: lighter;
      strong {
        font-weight: 500;
      }
    }
    small {
      font-size: 0.85rem;
    }
    a {
      color: #fff;
    }
  }

  @media only screen and (max-width: 576px) {
    header#header {
      .user-menu {
        & > a {
          display: none;
        }
        .dropdown-menu {
          display: block;
          width: 100% !important;
          position: relative;
          height: 520px;
          .inside-menu {
            .header {
              &.border-bottom {
                padding: 1rem 0.5rem !important;
              }
            }
          }
          box-shadow: none !important;
        }
      }
      .navbar-collapse {
        overflow: scroll !important;
        height: 90vh !important;
        .filled-dropdown {
          width: 100%;
        }
        .menu-nav-itens {
          display: block;
          .nav-item {
            display: block;
            line-height: 1 !important;
          }
        }
      }
      .navbar-collapse {
        @media only screen and (max-width: 991px) {
          display: block;
          overflow: scroll !important;
          height: 90vh !important;
        }
      }
    }
  }
  .inside-menu.notifications,
  .inside-menu.menu-all {
    overflow-y: auto;
    max-height: 90vh;
    &::-webkit-scrollbar {
      width: 6px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: rgb(173, 173, 173);
      border-radius: 10px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #fff;
    }
  }
  .navbar-toggler:focus {
    box-shadow: none !important;
  }
  .menu-nav-itens {
    @media screen and (max-width: 991px) {
      display: none;
    }
  }

  .nav-wrapper {
    @media screen and (min-width: 991px) {
      display: none;
    }
  }
  .navbar-collapse {
    flex-grow: 0;
  }
  #nav-collapse {
    margin-left: -150px;
    @media screen and (max-width: 1200px) {
      margin-left: -90px;
    }
    @media screen and (max-width: 991px) {
      margin-left: -200px;
    }
    @media screen and (max-width: 768px) {
      margin-left: -140px;
    }
    @media screen and (max-width: 576px) {
      margin-left: 0px;
    }
  }
</style>
